// Copyright (c) 2023 WiseTime. All rights reserved.

import { EMPTY, timer, mergeMap, Observable, of } from "rxjs"
import { Action } from "redux"
import { filter, withLatestFrom, takeUntil, repeat } from "rxjs/operators"
import * as Actions from "../actions"
import * as TimelineSlice from "../slices/timeline"
import { toTimelineDate } from "../dateTime"
import { DateTime } from "luxon"
import type { RootState } from "../../../app/store"
import { type VisibilityChange, visibilityChange } from "../../../app/visibilityChange"

export const syncCurrentDay = (visibilityChange: VisibilityChange) =>
  (action$: Observable<Action>, state$: Observable<RootState>): Observable<Action> =>
    action$.pipe(
      filter(Actions.syncCurrentDay.match),
      mergeMap(() => {
        const { pageVisible$, pageHidden$ } = visibilityChange()
        return timer(0, 60000).pipe(
          withLatestFrom(state$),
          mergeMap(([, state]) => {
            const actualDay = toTimelineDate(DateTime.local())
            if (state.timeline.currentDay !== actualDay) {
              return of(TimelineSlice.setCurrentDay(actualDay))
            } else {
              return EMPTY
            }
          }),
          takeUntil(pageHidden$),
          repeat({ delay: () => pageVisible$ }),
        )
      }),
    )

export default syncCurrentDay(visibilityChange)
